export enum TipoCumprimentoAvisoEnum {
  CUMPRIDO_TOTALMENTE = 0,
  CUMPRIDO_PARCIALMENTE_ARRUMOU_EMPREGO = 1,
  CUMPRIDO_PARCIALMENTE_INICIATIVA_EMPREGADO = 2,
  DISPENSADO = 3,
  DESCONTADO = 4,
}
